import { Box, Stack, Typography } from "@mui/material";
import { toPercent } from "src/utils/toPercent";

interface Props {
  value: number;
  indicatorLabel: string;
  zoneLabel: string;
  threshold: number[];
  zoneRange: number[];
  height?: number | string;
  color?: string;
  backgroundColor?: string;
}

const MedicationZone = ({
  value,
  indicatorLabel,
  zoneLabel,
  height = 48,
  threshold,
  zoneRange,
  color = "#ffffff",
  backgroundColor = "#00B6B9",
}: Props) => {
  const min = threshold[0];
  const max = threshold[threshold.length - 1];
  const zoneStart = toPercent(zoneRange[0], min, max);
  const zoneEnd = toPercent(zoneRange[1], min, max);
  const userValue = toPercent(value, min, max);

  const userZone = userValue >= zoneEnd ? 92 : userValue;

  return (
    <Stack gap={2}>
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height,
          bgcolor: backgroundColor,
          borderRadius: 24,
        }}
      >
        <Stack
          gap={0.3}
          sx={{
            position: "absolute",
            left: `${userZone}%`,
            top: -35,
            transform: "translateX(-50%)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            transition: "left 300ms ease-out",
            width: "max-content",
          }}
        >
          <Typography
            variant="body2"
            fontWeight={600}
            color={color}
            sx={{ textOverflow: "wrap" }}
          >
            {indicatorLabel}
          </Typography>
          <Box
            sx={{
              "&:before": {
                content: '""',
                width: 0,
                height: 0,
                borderLeft: 6 + "px solid transparent",
                borderRight: 6 + "px solid transparent",
                borderTop: 6 + `px solid ${color}`,
                marginBottom: 4,
              },
            }}
          />
        </Stack>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: `${zoneStart}%`,
            width: `${zoneEnd - zoneStart}%`,
            height: "100%",
            bgcolor: "common.white",
            borderRadius: 24,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography>{zoneLabel}</Typography>
        </Box>
      </Box>
      <Stack direction="row" justifyContent="space-between">
        {threshold.map((val) => (
          <Typography color={color} key={val}>
            {val}
          </Typography>
        ))}
      </Stack>
    </Stack>
  );
};

export default MedicationZone;
